import {defineMessages} from 'react-intl';

const messages = defineMessages({
	close: {
		id: 'cmsPreviewWidget.close',
		defaultMessage: 'X',
	},
	modeLabel: {
		id: 'cmsPreviewWidget.modeLabel',
		defaultMessage: 'Mode',
	},
	modeLive: {
		id: 'cmsPreviewWidget.modeLive',
		defaultMessage: 'Live',
	},
	modePreview: {
		id: 'cmsPreviewWidget.modePreview',
		defaultMessage: 'Preview',
	},
	apply: {
		id: 'cmsPreviewWidget.apply',
		defaultMessage: 'Apply CMS mode',
	},
	title: {
		id: 'cmsPreviewWidget.title',
		defaultMessage: 'CMS Preview',
	},
	entryInspectorLabel: {
		id: 'cmsPreviewWidget.entryInspectorLabel',
		defaultMessage: 'Edit buttons',
	},
	entryInspectorHint: {
		id: 'cmsPreviewWidget.entryInspectorHint',
		defaultMessage: 'Hover a content block to open its entry in the CMS',
	},
});

export default messages;
